<template>
  <li class="dropend">
    <a
      href="#"
      class="dropdown-item dropdown-toggle py-3"
      data-bs-toggle="dropdown"
      data-bs-auto-close="outside"
      >{{ title }}</a
    >
    <!-- <ul class="dropdown-menu shadow-navbar-custom-ff" :style="level >=2 ? 'position:static':''" style="max-height:90vh; overflow-y:auto"> -->
    <ul class="dropdown-menu shadow-navbar-custom-ff fs-nav-custom-ff">
      <li v-for="(child, index) in childs" :key="'second-' + index">
        <template v-if="!child.hasChild">
          <a v-if="child.url.slice(child.url.length - 4) == '.pdf'"
            target="_blank"
            @click="forceClickToggleBar()"
            class="nav-link nav-mobile px-3 py-3"
            :href="child.url"
            >{{ child.title }}</a
          >
          <Link v-else
            @click="width < 1147 ? forceClickToggleBar(): dekstopForceClickToggleBar(indexParent+2)"
            class="nav-link nav-mobile px-3 py-3" :class="{'active-custom-ff': isUrl(isTrueUrl(child.url))}"
            :href="child.url"
            >{{ child.title }}</Link
          >
          <li v-show="childs.indexOf(childs[index]) !== childs.length-1">
            <hr class="dropdown-divider m-0" style="border: 1px #ffffff solid" />
          </li>
        </template>
        <template v-else>
          <SecondLayerWithChild :title="child.title" :childs="child.childs" :width="width" :level="child.level" :indexParent="indexParent"/>
          <li v-show="childs.indexOf(childs[index]) !== childs.length-1">
            <hr class="dropdown-divider m-0" style="border: 1px #ffffff solid" />
          </li>
        </template>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  name: 'SecondLayerWithChild',
  props: {
    title: String,
    childs: Array,
    level: Number,
    width: Number,
    indexParent: Number,
  },

  methods: {
    isTrueUrl(href){
      if(href.startsWith('/id') || href.startsWith('/en')) {
        return href.substring(3);
      }

      if(href.startsWith('en') || href.startsWith('en')) {
        return href.substring(2);
      }

      return href;
    }
  },
};
</script>

<style>
</style>
